import Holidays from 'date-holidays';
const h = new Holidays();
h.init('US', {
  types: ['public']
});
export const isUSHoliday = date => Boolean(h.isHoliday(date));